import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../../atoms/icon/icon.component';
import { FormGroup } from '@angular/forms';
import { ErrorTypeLabels, FieldLabels, DEFAULT_ERROR_TYPE_LABELS } from '../../../shared/interfaces/error-messages.interface';

@Component({
  selector: 'htx-form-section',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './form-section.component.html',
  styleUrl: './form-section.component.scss'
})
export class FormSectionComponent {
  /**
   * The title of the form section
   */
  title = input<string>('');

  /**
   * Optional Material Icon name to display next to the title
   */
  icon = input<string>('');

  /**
   * Optional FormGroup associated with this section.
   */
  formGroup = input<FormGroup | undefined>(undefined);

  /**
   * Which control names belong to this section.
   */
  controlNames = input<string[] | undefined>(undefined);

  /**
   * Labels for the form fields in this section.
   */
  fieldLabels = input<FieldLabels>({});

  /**
   * Custom labels for error types.
   */
  errorTypeLabels = input<ErrorTypeLabels>(DEFAULT_ERROR_TYPE_LABELS);
}
